// src/components/Avatar.jsx

export const Avatar = ({ name }) => {
  if (!name) {
    // Si NO hay nombre, mantenemos el ícono genérico como fallback
    return (
      <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center mr-4">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
      </div>
    );
  }

  // Construimos la URL para la API de UI Avatars
  // encodeURIComponent se asegura de que los nombres con espacios o caracteres especiales funcionen bien
  const apiUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random&color=fff&bold=true&size=128`;

  return (
    <img
      src={apiUrl}
      alt={`Avatar de ${name}`}
      className="w-12 h-12 rounded-full mr-4"
    />
  );
};